import React, { Component } from "react";
import { Glyphicon, Col, Row, Grid } from "react-bootstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

import linkedIn from "../../../../assets/images/linked-in-black.svg";
import whitePage from "../../../../assets/images/whitePage.svg";
import website from "../../../../assets/images/website.svg";
import styles from "./Profile.scss";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import moment from "moment";

const INDUSTRY_OTHER = 38;

class Profile extends Component {
  getIndustryValue(industry, industry_other) {
    const id = _.get(industry, "id");
    const value = _.get(industry, "value");
    const other = industry_other || "-";

    if (value) {
      return id === INDUSTRY_OTHER ? `${value}: ${other}` : value;
    } else {
      return "-";
    }
  }

  render() {
    const { userData } = this.props;

    return (
      <section className={styles.profileContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <Grid className={styles.maxWidth}>
            <Row>
              <Col>
                <h1>
                  {userData && userData.first_name}
                  &nbsp;
                  {userData && userData.last_name}
                </h1>
                <p className={styles.subtitle}>
                  Member since{" "}
                  {userData && moment(userData.created_at).format("MMMM YYYY")}
                </p>
                &nbsp;
              </Col>
            </Row>
            <Row>
              <div className={styles.dividerDouble} />
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Summary</h2>
              <Link to="profile/summary">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>City and State</h3>
                  {userData.profile && userData.profile.city}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>
                    Closest metro area
                  </h3>
                  {userData.profile &&
                    userData.profile.commute_city &&
                    userData.profile.commute_city.value}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>Primary Industry</h3>
                  {this.getIndustryValue(
                    _.get(userData, "profile.primary_industry"),
                    _.get(userData, "profile.primary_industry_other")
                  )}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>
                    Secondary Industry
                  </h3>
                  {this.getIndustryValue(
                    _.get(userData, "profile.secondary_industry"),
                    _.get(userData, "profile.secondary_industry_other")
                  )}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>
                    Professional Summary
                  </h3>
                  {userData && userData.professional_summary}
                </div>
                {userData && (
                  <div>
                    <div className={styles.divider} />
                    <p className={styles.summarySubheader}>
                      This member is {!userData.full_time_job && "not"}{" "}
                      available for a full-time, on-staff role.
                    </p>
                  </div>
                )}
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Additional Materials</h2>
              <Link to="profile/additional-materials">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                {userData && userData.profile && (
                  <div>
                    <div className={styles.linksFlex}>
                      <p>
                        <img src={whitePage} className={styles.logos} />
                        <span className={styles.materialsSpan}>Resumé </span>

                        {userData &&
                        userData.profile &&
                        userData.profile.resume ? (
                          <span>
                            <a
                              href="#"
                              onClick={this.props.downloadResume}
                              data-download="false"
                            >
                              Download
                            </a>
                          </span>
                        ) : (
                          <Link to="/member/profile/additional-materials">
                            Add your resume
                          </Link>
                        )}
                      </p>
                    </div>
                    <div className={styles.divider} />
                  </div>
                )}
                {userData &&
                  userData.links &&
                  userData.links.map((link, index) => {
                    let url = link.url;
                    if (!url) return null;
                    if (
                      url.indexOf("http://") < 0 &&
                      url.indexOf("https://") < 0
                    )
                      url = "//" + url;

                    return (
                      <div key={index}>
                        {link.category.indexOf("linkedin") >= 0 && (
                          <div>
                            {index > 0 && <div className={styles.divider} />}
                            <div className={styles.linksFlex}>
                              <p>
                                <img src={linkedIn} className={styles.logos} />
                                <span className={styles.materialsSpan}>
                                  LinkedIn
                                </span>
                                <a href={url} target="_blank">
                                  {link.url}
                                </a>
                              </p>
                            </div>
                          </div>
                        )}
                        {link.category.indexOf("website") >= 0 && (
                          <div>
                            {index > 0 && <div className={styles.divider} />}
                            <div className={styles.linksFlex}>
                              <p>
                                <img src={website} className={styles.logos} />
                                <span className={styles.materialsSpan}>
                                  Website
                                </span>
                                <a href={url} target="_blank">
                                  {link.url}
                                </a>
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Skills</h2>
              <Link to="profile/skills">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div>
                  {userData &&
                    userData.skills_all &&
                    Object.entries(userData.skills_all).map((skills, index) => {
                      const skillsArray = skills[1];
                      if (skillsArray && skillsArray.length > 0) {
                        return (
                          <div key={index}>
                            {index > 0 && <div className={styles.divider} />}
                            <h3>{skillsArray[0].description.category.name}</h3>
                            <ul>
                              {skillsArray.map((skill, index) => {
                                return (
                                  <li key={index}>{skill.description.name}</li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Work History</h2>
              <Link to="profile/work-history">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                {userData &&
                  userData.work_history &&
                  userData.work_history.map((work, index) => {
                    if (!work[0]) return null;
                    return (
                      <div key={index}>
                        {index > 0 && <div className={styles.divider} />}
                        <h3>{work[0].name}</h3>
                        <p className={styles.historyContent}>
                          {work[0].role} | {work[0].years}
                          {work[0].years > 1 ? " years" : " year"}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Education</h2>
              <Link to="profile/education">
                <Glyphicon glyph="pencil" /> Edit
              </Link>
              &nbsp;
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                {userData &&
                  userData.education &&
                  userData.education.map((education, index) => {
                    if (!education[0]) return null;
                    return (
                      <div key={index}>
                        {index > 0 && <div className={styles.divider} />}
                        <h3>{education[0].value}</h3>
                        <p className={styles.historyContent}>
                          {education[0].degree}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </Row>
          </Grid>
        </section>
      </section>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/Profile.js